import type { Hook } from 'phoenix_live_view';
import { flashNotification } from '../../rescript/src/hooks/FlashNotificationHook.res.mjs';
import { processingNotificationPanel } from '../../rescript/src/hooks/ProcessingNotificationPanelHook.res.mjs';
import { relativeTime } from '../../rescript/src/hooks/RelativeTimeHook.res.mjs';
import { notificationsNavSync } from '../../rescript/src/hooks/NotificationsNavSyncHook.res.mjs';
import { snippetEditor } from '../../rescript/src/hooks/SnippetEditorHook.res.mjs';
import { gamesListCollapse } from '../../rescript/src/hooks/GamesListCollapseHook.res.mjs';
import { hubGamesHoverPanel } from '../../rescript/src/hooks/HubGamesHoverPanelHook.res.mjs';
import { mainNavRail } from '../../rescript/src/hooks/MainNavRailHook.res.mjs';
import { popover } from '../../rescript/src/hooks/PopoverHook.res.mjs';
import { selectDropdown } from '../../rescript/src/hooks/SelectDropdownHook.res.mjs';
import { libraryImageFallback } from '../../rescript/src/hooks/LibraryImageFallbackHook.res.mjs';
import { themeSwitcher } from '../../rescript/src/hooks/ThemeSwitcherHook.res.mjs';
import { resizableTray } from '../../rescript/src/hooks/ResizableTrayHook.res.mjs';
import { selectTableRow } from '../../rescript/src/hooks/SelectTableRowHook.res.mjs';
import { loadFeedbackStats } from './load-feedback-stats';
import { loadSentimentStats } from './load-sentiment-stats';
import { loadPlayerStats } from './load-player-stats';
import { loadDecisionSurfaceLite } from './load-decision-surface-lite';
import { resizableColumns } from '../../rescript/src/hooks/ResizableColumnsHook.res.mjs';
import { SelectAllHeader } from '../../rescript/src/hooks/SelectAllHeaderHook.res.mjs';
import { reviewRow } from '../../rescript/src/hooks/ReviewRowHook.res.mjs';
import { preserveScroll } from '../../rescript/src/hooks/PreserveScrollHook.res.mjs';
import { preserveDetailsOpen } from '../../rescript/src/hooks/PreserveDetailsOpenHook.res.mjs';
import { selectableRow } from '../../rescript/src/hooks/SelectableRowHook.res.mjs';
import { snippetSplit } from '../../rescript/src/hooks/SnippetSplitHook.res.mjs';
import { creditFlash } from '../../rescript/src/hooks/CreditFlashHook.res.mjs';
import { guideTray } from '../../rescript/src/hooks/GuideTrayHook.res.mjs';
import { tooltipEscapeClip } from '../../rescript/src/hooks/TooltipEscapeClipHook.res.mjs';
import { AppNav } from '../../rescript/src/hooks/AppNavHook.res.mjs';
import StripePayment from './stripe-payment';
import { AccountBarMeasure } from '../../rescript/src/hooks/AccountBarMeasureHook.res.mjs';
import { inboxSnippetFocus } from '../../rescript/src/hooks/InboxSnippetFocusHook.res.mjs';
import {
  assistantChat,
  assistantChatInput,
} from '../../rescript/src/hooks/AssistantChatHook.res.mjs';
import { GdChart } from '../../rescript/src/hooks/GdChartHook.res.mjs';
import { NotebookToc } from '../../rescript/src/hooks/NotebookTocHook.res.mjs';
import { CalendarTimeline } from '../../rescript/src/hooks/CalendarTimelineHook.res.mjs';
import { columnPickerPersist } from '../../rescript/src/hooks/ColumnPickerPersistHook.res.mjs';
import { HeroSlideshow } from '../../rescript/src/hooks/HeroSlideshowHook.res.mjs';

const hooks = {
  gamesListCollapse,
  hubGamesHoverPanel,
  mainNavRail,
  flashNotification,
  processingNotificationPanel,
  relativeTime,
  notificationsNavSync,
  popover,
  selectDropdown,
  libraryImageFallback,
  themeSwitcher,
  snippetEditor,
  resizableTray,
  resizableColumns,
  selectTableRow,
  SelectAllHeader,
  reviewRow,
  preserveScroll,
  preserveDetailsOpen,
  selectableRow,
  loadFeedbackStats,
  loadSentimentStats,
  loadPlayerStats,
  loadDecisionSurfaceLite,
  snippetSplit,
  creditFlash,
  guideTray,
  tooltipEscapeClip,
  AppNav,
  StripePayment,
  AccountBarMeasure,
  inboxSnippetFocus,
  assistantChat,
  assistantChatInput,
  GdChart,
  NotebookToc,
  CalendarTimeline,
  columnPickerPersist,
  HeroSlideshow,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} satisfies Record<string, Hook<any>>;

export default hooks;
